import {
  Logout05Icon,
  Settings01Icon,
  UserSettings01Icon,
} from "@hugeicons/core-free-icons"
import { HugeiconsIcon } from "@hugeicons/react"
import {
  SidebarMenu,
  SidebarMenuAction,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@motleyhand/design"
import { Link, useMatchRoute } from "@tanstack/react-router"
import { useLogout, useMaybeTenant } from "@/auth"

export default function FooterMenu() {
  const tenantSlug = useMaybeTenant()
  const logout = useLogout()
  const matchRoute = useMatchRoute()
  const isSettingsActive = !!matchRoute({
    to: "/t/$tenantSlug/settings",
    fuzzy: true,
  })
  const isAccountActive =
    !!matchRoute({ to: "/t/$tenantSlug/account", fuzzy: true }) ||
    !!matchRoute({ to: "/account", fuzzy: true })

  return (
    <SidebarMenu>
      {tenantSlug && (
        <SidebarMenuItem>
          <SidebarMenuButton
            isActive={isSettingsActive}
            render={
              <Link to="/t/$tenantSlug/settings" params={{ tenantSlug }}>
                <HugeiconsIcon icon={Settings01Icon} />
                Settings
              </Link>
            }
          />
        </SidebarMenuItem>
      )}
      <SidebarMenuItem>
        <SidebarMenuButton
          isActive={isAccountActive}
          render={
            <Link
              to={tenantSlug ? "/t/$tenantSlug/account" : "/account"}
              params={tenantSlug ? { tenantSlug } : undefined}
            >
              <HugeiconsIcon icon={UserSettings01Icon} />
              Account
            </Link>
          }
        />
        <SidebarMenuAction title="Logout" onClick={logout}>
          <HugeiconsIcon icon={Logout05Icon} />
        </SidebarMenuAction>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
